import * as api from '../api';
import { Model } from '../common';

@Model('LogMessage')
export class LogMessage extends api.ApiLogMessage {

    static ROOT_URL = '/logs';
    static API = api.LogsApi;

    public send(): Promise<void> {
        return <any>LogMessage
            .inject(api.LogsApi)
            .sendOne(this.getData())
            .toPromise()
        ;
    }

    public static sendBatch(batch : LogMessage[]) {
        return <any>LogMessage
            .inject(api.LogsApi)
            .sendBatch({ 
                batch: batch.map(x => x.getData())
            })
            .toPromise()
        ;
    }

    public static sendCrash(title : string, batch : LogMessage[]) {
        return <any>LogMessage
            .inject(api.LogsApi)
            .sendCrash({ 
                title: title,
                batch: batch.map(x => x.getData())
            })
            .toPromise()
        ;
    }

}